<!--
 * @Description: 
 * @Autor: yd
 * @Date: 2020-07-02 19:29:11
 * @LastEditors: yd
 * @LastEditTime: 2020-11-11 10:28:49
--> 
<template>
  <div>
    <version :disabled='false'></version>
  </div>
</template> 
 
<script>
import version from './version'
export default {
  components: {
    version
  },
  data () {
    return {
    }
  },
  mounted () {
  },
  methods: {

  },
  watch: {
  }
}
</script>